import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { BpgMembershipComponent } from './bpg-membership/bpg-membership.component';
import { BpgSiteHomePageComponent } from './bpg-common/bpg-site-home-page/bpg-site-home-page.component';

import { EventsCalendarComponent } from './bpg-events/events_calendar/events-calendar/events-calendar.component';
import { LoginComponent } from './login/login.component';
import { BpgListComponent } from './bpg-membership/bpg-list/bpg-list.component';
import { BpgInterestComponent } from './bpg-membership/bpg-interest/bpg-interest.component';
import { BpgSkillListComponent } from './bpg-membership/bpg-skill-list/bpg-skill-list.component';
import { BpgLeadershipComponent } from './bpg-membership/bpg-leadership/bpg-leadership.component';
import { BpgDemographicsComponent } from './bpg-membership/bpg-demographics/bpg-demographics.component';
import { BpgMembershipPreviewComponent } from './bpg-membership/bpg-membership-preview/bpg-membership-preview.component';
import { AreaOfImpactComponent } from './bpg-self-services/area-of-impact/area-of-impact.component';
import { BpgComponent } from './bpg-self-services/bpg/bpg.component';
import { DemographicsComponent } from './bpg-self-services/demographics/demographics.component';
import { SiteComponent } from './bpg-self-services/site/site.component';
import { BpgChapterHomePageComponent } from './bpg-chapter-home-page/bpg-chapter-home-page.component';
import { ChapterComponent } from './bpg-self-services/chapter/chapter.component';
import { AuthGuard } from './auth.guard';
import { AnnualPlanFeatureFlagGuard } from './annual-plan/guards/annual-plan-feature-flag.guard';
import { BpgMembershipPreviewSuccessComponent } from './bpg-membership/bpg-membership-preview-success/bpg-membership-preview-success.component';
import { EventsListViewComponent } from './bpg-events/events-list-view/events-list-view.component';
import { BpgEventsComponent } from './bpg-events/bpg-events.component';
import { EventViewDetailsComponent } from './bpg-events/event-view-details/event-view-details.component';
import { EventsApprovalComponent } from './bpg-events/events-approval/events-approval.component';
import { BpgCreateAndEditEventComponent } from './bpg-events/bpg-create-and-edit-event/bpg-create-and-edit-event.component';
import { AdminComponent } from './bpg-admin/admin/admin.component';
import { CreateAndEditExpenseClaimComponent } from './bpg-expenses/create-and-edit-expense-claim/create-and-edit-expense-claim.component';
import { ClaimExpenseApprovalComponent } from './bpg-expenses/claim-expense-approval/claim-expense-approval.component';
import { CreateAndEditHoshinComponent } from './bpg-hoshin/create-and-edit-hoshin/create-and-edit-hoshin.component';
import { HoshinListingComponent } from './bpg-hoshin/hoshin-listing/hoshin-listing.component';
import { TakeSurveyComponent } from './bpg-survey/take-survey/take-survey.component';
import { CreateSurveyComponent } from './bpg-survey/create-survey/create-survey.component';
import { SurveyPreviewComponent } from './bpg-survey/survey-preview/survey-preview.component';
import { ReportsComponent } from './reports/reports/reports.component';
import { LoginErrorComponent } from './login-error/login-error.component';
import { ViewHoshinComponent } from './bpg-hoshin/view-hoshin/view-hoshin.component'
import { LogOutComponent } from './log-out/log-out.component';
import { EditApprovalHoshinComponent } from './bpg-hoshin/edit-approval-hoshin/edit-approval-hoshin.component'
import { ChapterAdminComponent } from './bpg-admin/chapter-admin/chapter-admin.component';
import { BpgDiHomePageComponent } from './bpg-di-home-page/bpg-di-home-page.component';
import { DIComponent } from './bpg-self-services/d-i/d-i.component';
import { ConfigureGalleryComponent } from './bpg-self-services/configure-gallery/configure-gallery.component';
import { DocumentRepositoryComponent } from './bpg-self-services/document-repository/document-repository.component';
import { ManageFolderComponent } from './bpg-self-services/manage-folder/manage-folder.component';
import { EventReportComponent } from './bpg-events/event-report/event-report.component';
import { MembershipReportComponent } from './bpg-self-services/membership-report/membership-report.component';
import { BpgSiteComponent } from './bpg-membership/bpg-site/bpg-site.component';
import { EmailManagementComponent } from './bpg-self-services/email-management/email-management.component';
import { AdditionalresourceFolderComponent } from './bpg-self-services/additionalresource-folder/additionalresource-folder.component';
import { NaacComponent } from './bpg-self-services/naac/naac.component';
import { NaacHomePageComponent } from './bpg-common/naac-home-page/naac-home-page.component';
import { NaacFolderComponent } from './bpg-self-services/naac-folder/naac-folder.component';
import { NaacAdminComponent } from './bpg-admin/naac-admin/naac-admin.component';
import { ChapterAnnouncementsComponent } from './bpg-self-services/chapter-announcements/chapter-announcements.component';
import { PushNotificationComponent } from './bpg-self-services/push-notification/push-notification.component';
import { UserMembershipComponent } from './bpg-membership/user-membership/user-membership.component';
import { HoshinComponent } from './bpg-hoshin/hoshin/hoshin.component';
import { HoshinHomeComponent } from './bpg-hoshin/hoshin-home/hoshin-home.component';
import { MembershipGroupSignUpComponent } from './bpg-self-services/membership-group-sign-up/membership-group-sign-up.component';
import { EventsComponent } from './bpg-events/events/events.component';
import { ExpenseComponent } from './bpg-expenses/expense/expense.component';
import { BPGAdminHomePageComponent } from './bpg-admin-home-page/bpg-admin-home-page.component';
import { RoleGuard } from './role.guard';
import { ActualsComponent } from './bpg-expenses/actuals/actuals.component';
import { PushNotificationLogsComponent } from './bpg-self-services/push-notification/push-notification-logs/push-notification-logs.component';
import { TnCComponent } from './tnc/tnc.component';
import { OmnidashboardComponent } from './omnidashboard/omnidashboard.component';

const routes: Routes = [
  { path: '', redirectTo: '/di-home', pathMatch: 'full' },
  { path: 'di-home', component: BpgDiHomePageComponent, canActivate: [AuthGuard] },
  { path: 'bpg-admin-home', redirectTo: 'erg-admin-home', pathMatch: 'full' },
  { path: 'erg-admin-home', component: BPGAdminHomePageComponent, canActivate: [RoleGuard,AuthGuard] },
  { path: 'login', component: LoginComponent, canActivate: [AuthGuard] },
  { path: 'site-home', component: BpgSiteHomePageComponent, canActivate: [AuthGuard] },
  { path: 'events-calendar', component: EventsCalendarComponent, canActivate: [AuthGuard] },
  { path: 'area-of-impact-services', component: AreaOfImpactComponent, canActivate: [AuthGuard] },
  { path: 'erg-services', component: BpgComponent, canActivate: [AuthGuard] },
  { path: 'demographics-services', component: DemographicsComponent, canActivate: [AuthGuard] },
  { path: 'site-services', component: SiteComponent, canActivate: [AuthGuard] },
  { path: 'chapter-home', component: BpgChapterHomePageComponent, canActivate: [AuthGuard] },
  { path: 'chapter-services', component: ChapterComponent, canActivate: [AuthGuard] },
  { path: 'events-list-view', component: EventsListViewComponent, canActivate: [AuthGuard] },
  { path: 'erg-events', component: BpgEventsComponent, canActivate: [AuthGuard] },
  { path: 'events', component: EventsComponent, canActivate: [AuthGuard] },
  { path: 'event-view-details', component: EventViewDetailsComponent, canActivate: [AuthGuard] },
  { path: 'event-view-details/:id', component: EventViewDetailsComponent, canActivate: [AuthGuard] },
  { path: 'events-approval', component: EventsApprovalComponent, canActivate: [AuthGuard] },
  { path: 'create-event', component: BpgCreateAndEditEventComponent, canActivate: [AuthGuard] },
  { path: 'admin', component: AdminComponent, canActivate: [AuthGuard] },
  { path: 'expense-list', component: ExpenseComponent, canActivate: [AuthGuard] },
  { path: 'expense-claim', component: CreateAndEditExpenseClaimComponent, canActivate: [AuthGuard] },
  { path: 'expense-claim/:id', component: CreateAndEditExpenseClaimComponent, canActivate: [AuthGuard] },
  { path: 'claim-expense-approval/:id', component: ClaimExpenseApprovalComponent, canActivate: [AuthGuard] },
  { path: 'claim-expense-approval', component: ClaimExpenseApprovalComponent, canActivate: [AuthGuard] },
  // { path: 'create-annual-plan', component: CreateAndEditHoshinComponent, canActivate: [AuthGuard] },
  // { path: 'annual-plan-listing', component: HoshinListingComponent, canActivate: [AuthGuard] },
  { path: 'create-survey', component: CreateSurveyComponent, canActivate: [AuthGuard] },
  { path: 'survey-preview', component: SurveyPreviewComponent, canActivate: [AuthGuard] },
  { path: 'take-survey', component: TakeSurveyComponent, canActivate: [AuthGuard] },
  { path: 'take-survey/:id', component: TakeSurveyComponent, canActivate: [AuthGuard] },
  { path: 'reports', component: ReportsComponent, canActivate: [AuthGuard] },
  { path: 'login-error', component: LoginErrorComponent, canActivate: [AuthGuard] },
  // { path: 'view-annual-plan', component: ViewHoshinComponent, canActivate: [AuthGuard] },
  { path: 'log-out', component: LogOutComponent, canActivate: [AuthGuard] },
  // { path: 'edit-approval', component: EditApprovalHoshinComponent, canActivate: [AuthGuard] },
  { path: 'chapter-admin', component: ChapterAdminComponent, canActivate: [AuthGuard] },
  { path: 'configure-gallery', component: ConfigureGalleryComponent, canActivate: [AuthGuard] },
  { path: 'BCE-Services', component: DIComponent, canActivate: [AuthGuard] },
  { path: 'document-repository', component: DocumentRepositoryComponent, canActivate: [AuthGuard] },
  { path: 'manage-folder', component: ManageFolderComponent, canActivate: [AuthGuard] },
  { path: 'email-management', component: EmailManagementComponent, canActivate: [AuthGuard] },
  { path: 'additionalresource-folder', component: AdditionalresourceFolderComponent, canActivate: [AuthGuard] },
  { path: 'naac', component: NaacComponent, canActivate: [AuthGuard] },
  { path: 'naac-home', component: NaacHomePageComponent, canActivate: [AuthGuard] },
  { path: 'naac-folder', component: NaacFolderComponent, canActivate: [AuthGuard] },
  { path: 'naac-admin', component: NaacAdminComponent, canActivate: [AuthGuard] },
  { path: 'actuals', component: ActualsComponent, canActivate: [AuthGuard]},
  { path: 'chapter-announcements', component: ChapterAnnouncementsComponent, canActivate: [AuthGuard] },
  { path: 'push-notification', component: PushNotificationComponent, canActivate: [AuthGuard] },
  { path: 'push-notification-logs', component: PushNotificationLogsComponent, canActivate: [AuthGuard]},
  { path: 'membership/site', component: BpgSiteComponent, canActivate: [AuthGuard] },
  { path: 'user-membership', component: UserMembershipComponent, canActivate: [AuthGuard]},
  { path: 'annual-plan', component: HoshinComponent, canActivate: [AuthGuard]},
  { path: 'hoshin-home', redirectTo: 'annual-plan-home', pathMatch: 'full'},
  { path: 'annual-plan-home', component:  HoshinHomeComponent, canActivate: [AuthGuard]},
  { path: 'annual-plan-v2', loadChildren: './annual-plan/annual-plan.module#AnnualPlanModule',
    canActivate: [AuthGuard], canLoad: [AnnualPlanFeatureFlagGuard]},
  { path: 'membership-group-sign-up', component: MembershipGroupSignUpComponent, canActivate: [AuthGuard]},
  { path: 't&c', component: TnCComponent, canActivate: [AuthGuard]},
  { path: 'omnidashboard', component: OmnidashboardComponent, canActivate: [RoleGuard, AuthGuard]},
  {
    path: 'membership', component: BpgMembershipComponent,
    children: [
      { path: '', redirectTo: 'site', pathMatch: 'full' },
      {
        path: 'site',
        component: BpgSiteComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'erg',
        component: BpgListComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'interests',
        component: BpgInterestComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'skills',
        component: BpgSkillListComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'leadership',
        component: BpgLeadershipComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'preview',
        component: BpgMembershipPreviewComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'demographics',
        component: BpgDemographicsComponent,
        canActivate: [AuthGuard]
      },
      { path: 'preview-success', component: BpgMembershipPreviewSuccessComponent, canActivate: [AuthGuard] }

    ]
  },
  { path: 'event-report', component: EventReportComponent, canActivate: [AuthGuard] },
  { path: 'succession-planning', component: MembershipReportComponent, canActivate: [AuthGuard] }

]


@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
